import { useQuery } from "@tanstack/react-query"
import { useState } from "react";
import { DatesFilter } from "../components/filters/DatesFilter";
import { getDespesasTotal, getFaturacaoFornecedoresTotal, getFaturacaoPorFornecedor } from "../../services/charts.service";
import { MultipleLinesPlot } from "./MulitpleLinePlot";
import { genericGet } from "../../services/api.service";


const getPastYearCurrentDate = () => {

    const date = new Date(Date.now());
    date.setFullYear(date.getFullYear() - 1);
    date.setMonth(date.getMonth() + 1);
    return date;
}

export function DespesasChart() {

    const [startDate, setStartDate] = useState<Date>(getPastYearCurrentDate());
    const [endDate, setEndDate] = useState<Date>(new Date(Date.now()));

    const { data: fornecedores } = useQuery({
        queryKey: ['fornecedores'],
        queryFn: async () => await genericGet('/fornecedores?page=1&take=1000'),
    })

    const { data: data } = useQuery({
        queryKey: ['lineChart', startDate, endDate, fornecedores],
        queryFn: async () => await Promise.all([
            getDespesasTotal(startDate.toISOString().split('T')[0], endDate.toISOString().split('T')[0]),
            getFaturacaoFornecedoresTotal(startDate.toISOString().split('T')[0], endDate.toISOString().split('T')[0]),
            ...fornecedores?.data?.map((f: { id: string }) => {
                return getFaturacaoPorFornecedor(startDate.toISOString().split('T')[0], endDate.toISOString().split('T')[0], f.id);
            })
        ]),
        onSuccess: (data) => console.log("Received: ", data),
    })


    return (<div>
        <h1 className='font-bold text-[1.5em] pl-5 pb-1'>Despesas</h1>


        <div className="p-2 flex">

            <div className="w-full">
                <div className="w-full h-auto ">
                    <MultipleLinesPlot data={data} startDate={startDate} endDate={endDate} />
                </div>
                <DatesFilter startDate={startDate} setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate} />
            </div>
        </div>
    </div>
    )

}